import { Typography } from 'app/component-library-wave';
import { Trans, useTranslation } from 'react-i18next';
import { useAppSelector } from 'app/hooks/redux-thunk';

import { navigationService } from 'app/service/navigation/navigation-service';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { NetworkMenuItem } from '../network-menu-item';
import { FALLBACK_SELFCARE_HGW_URL } from 'app/pages/internet/network-common';
import { getDataLayers } from 'app/utils/trackingService';
import { getAnonymizedCurrentPageUrl, GtmElementCta } from 'app/utils/gtm-tracking-utils';

import styles from '../../wifi-settings.module.scss';

interface Props {
  canToggleBridge: boolean;
}
export const BridgeMode = ({ canToggleBridge }: Props) => {
  const { t } = useTranslation();
  const { goToPath } = useAppNavigation();
  const { data: networkData } = useAppSelector((state) => state.network);
  const { data: equipmentEnrichment } = useAppSelector((state) => state.enrichment.equipment);
  const isOn = networkData?.hgw.bridge;

  if (!canToggleBridge) {
    return null;
  }

  const hgwEnrichment = equipmentEnrichment?.find(
    (equipment) => equipment.provSpecificationId === networkData?.hgw.type,
  );

  const handleBridgeModeClick = () => {
    getDataLayers().customEvents.pushButtonClickEvent({
      page_url: getAnonymizedCurrentPageUrl(),
      element_url: navigationService.PAGES.internetSettingsWifiBridgeMode.url,
      element_cta: GtmElementCta.INTERNET_SETTINGS_BRIDGE_MODE,
    });
    goToPath(navigationService.PAGES.internetSettingsWifiBridgeMode.url);
  };

  return (
    <NetworkMenuItem
      networkData={networkData}
      menuText={t('pages.network.advanced.settings.sections.bridge.name')}
      helpTextHeader={t('pages.network.advanced.settings.helpTexts.bridge.title')}
      onClick={handleBridgeModeClick}
      actionElement={
        isOn
          ? t('pages.network.advanced.settings.sections.bridge.statusOn')
          : t('pages.network.advanced.settings.sections.bridge.statusOff')
      }
    >
      <div className={styles.informationText}>
        <Typography variant="paragraph3" component="p" className={styles.helpText}>
          {t('pages.network.advanced.settings.helpTexts.bridge.paragraph1.content')}
        </Typography>
        <Typography variant="paragraph3" component="p" className={styles.helpText}>
          {t('pages.network.advanced.settings.helpTexts.bridge.paragraph2.content')}
        </Typography>
        {(hgwEnrichment?.bridgeModePortLabel && (
          <Typography variant="paragraph3" component="p" className={styles.helpText}>
            {t('pages.network.advanced.settings.helpTexts.bridge.port.known', {
              bridgeModePortLabel: hgwEnrichment.bridgeModePortLabel,
            })}
          </Typography>
        )) || (
          <Typography variant="paragraph3" component="p" className={styles.helpText}>
            <Trans i18nKey={'pages.network.advanced.settings.helpTexts.bridge.port.unknown'}>
              placeholdertext
              <a href={hgwEnrichment?.customerServiceUrl || FALLBACK_SELFCARE_HGW_URL} />
            </Trans>
          </Typography>
        )}
      </div>
    </NetworkMenuItem>
  );
};
